// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__X-OTO","button":"styles_button__Y9kWX","button_active":"styles_button_active__tsQgL","button_":"styles_button___RDx3H"};